var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencilEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79606 1.17586L8.88887 0.264235C8.53827 -0.0880783 7.96898 -0.0880783 7.61719 0.264235L6.7482 1.13748L8.78242 3.18167L9.79606 2.16307C10.068 1.8898 10.068 1.44912 9.79606 1.17586ZM6.21825 1.66887L8.25247 3.71304L3.10328 8.88745L1.07021 6.84328L6.21825 1.66887ZM0.285695 9.99325C0.119066 10.034 -0.0313595 9.88395 0.00566077 9.71652L0.519426 7.39678L2.5525 9.44095L0.285695 9.99325Z",
    fill: "#585B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencilEdit);
export default __webpack_public_path__ + "static/media/ic_pencil_edit.8b1f68ba57ddcf345bf04ecc91e3df52.svg";
export { ForwardRef as ReactComponent };